/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * My Emissions API
 * We calculate food carbon footprints
 * OpenAPI spec version: 1.0.0 (v1)
 */

/**
 * * `farm_producer` - Farm / producer
* `manufacturer` - Manufacturer
* `wholesaler` - Wholesaler
* `international_supplier` - International supplier
 */
export type TypeOfSuppliersEnum = typeof TypeOfSuppliersEnum[keyof typeof TypeOfSuppliersEnum];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TypeOfSuppliersEnum = {
  farm_producer: 'farm_producer',
  manufacturer: 'manufacturer',
  wholesaler: 'wholesaler',
  international_supplier: 'international_supplier',
} as const;
